import * as React from 'react';

const SvgMicrosoft = (props) => (
  <svg
    width={17}
    height={16}
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_11_36562)">
      <path
        d="M-0.00634766 -0.420898H7.6046V7.19005H-0.00634766V-0.420898Z"
        fill="#E95228"
      />
      <path
        d="M8.38892 -0.420898H15.9999V7.19005H8.38892V-0.420898Z"
        fill="#7EBA28"
      />
      <path
        d="M-0.00634766 7.98926H7.6046V15.5857H-0.00634766V7.98926Z"
        fill="#339FDA"
      />
      <path
        d="M8.38892 7.98926H15.9999V15.5857H8.38892V7.98926Z"
        fill="#FBB811"
      />
    </g>
    <defs>
      <clipPath id="clip0_11_36562">
        <rect width={16} height={16} fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgMicrosoft;
